<template>
  <div class="container text-with-image-slider">
    <default-title
      v-if="title"
      class="text-with-image-slider__section-title"
      :title="title"
      :title_tag="title_tag"/>
    <swiper
      class="text-with-image-slider__swiper"
      :loop="slides.length > 1"
      :hide_navigation_buttons="slides.length < 2"
      add_navigation_buttons
      prev_btn_class="text-with-image-slider__prev"
      next_btn_class="text-with-image-slider__next">
      <swiper-slide
        v-for="(slide, index) in slides"
        :key="`slide_${index}_${uid}`">
        <div
          class="text-with-image-slider__panel"
          :class="{'text-with-image-slider__panel_reversed': slide.image_from_right}">
          <lazy-image
            class="text-with-image-slider__image"
            cover_img
            :src="slide.image_src"
            :lazy_src="slide.image_lazy_src"
            :alt="slide.title || 'slide'"/>
          <div class="text-with-image-slider__text">
            <default-title
              v-if="slide.title"
              class="text-with-image-slider__title"
              pre_wrap
              :title="slide.title"
              title_tag="div"/>
            <html-block
              v-if="slide.content"
              class="text-with-image-slider__content"
              :content="slide.content"/>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import LazyImage from "../small_parts/LazyImage.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import uid_mixin from "../../mixins/uid_mixin";

export default {
  name: "TextWithImageSlider",
  mixins: [uid_mixin],
  components: {
    SwiperSlide,
    Swiper,
    DefaultTitle,
    LazyImage,
    HtmlBlock
  },
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h2',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    slides: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        image_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        image_lazy_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'textarea',
        },
        content: {
          type: String,
          default: '',
          admin_type: 'editor',
        },
        image_from_right: {
          type: Boolean,
          default: false,
          admin_type: 'checkbox',
        },
      }
    },
    /**props**/
  }
}
</script>
